import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { Toaster } from "react-hot-toast";
import ScrollToTop from "./components/pages/ScrollToTop";

// COMPONENTS
import Header from "./components/molecules/Header";
import Home from "./components/pages/Home";
import Login from "./components/pages/Login";
import Register from "./components/pages/Register";
import ForgotPassword from "./components/pages/ForgotPassword";
import PandithParichayaPage from "./components/pages/PandithParichayaPage";
import PurohitDashBoardPage from "./components/pages/PurohitDashBoardPage";
import TempleDashboard from "./components/pages/TempleSevasDashboard";
import TempleRegistration from "./components/pages/Templeregistration";
import TempleEditPage from "./components/pages/Templeeditpage"
import PoojaKitsPage from "./components/pages/PoojaKitsPage";



// import UserPaymentPage from "./components/pages/UserPaymentPage";
import UnbluredPurohitDetailsPage from "./components/pages/UnbluredPurohitDetailsPage";
import Dashboard from "./components/pages/UserDashboardPage";
import Footer from "./components/molecules/Footer";

import PurohitEditPage from "./components/pages/PurohitEditPage";
import PurohitRegistrationPage from "./components/pages/PurohitRegistrationPage";
import PurohitSubscriptionPage from "./components/pages/PurohitSubscriptionPage";

// ⭐ Legal Pages
import TermsAndConditionsPage from "./components/pages/TermsAndConditionsPage";
import PrivacyPolicyPage from "./components/pages/PrivacyPolicyPage";
import TermsPrivacyAgreement from "./components/pages/TermsPrivacyAgreement";
import TempleSevasPage from "./components/pages/TempleSevasPage";

export default function App() {
  const [isLoggedIn, setIsLoggedIn] = useState(
    localStorage.getItem("loggedIn") === "true"
  );

  return (
    <Router>
      {/* ✅ Scroll to top on every route change */}
      <ScrollToTop />

      {/* Toast Notifications */}
      <Toaster
        position="top-center"
        reverseOrder={false}
        toastOptions={{
          duration: 3000,
          style: {
            textAlign: "center",
            fontSize: "14px",
            padding: "12px 16px",
          },
        }}
      />

      <Header isLoggedIn={isLoggedIn} setIsLoggedIn={setIsLoggedIn} />

      <Routes>
        {/* Public Routes */}
        <Route path="/" element={<Home />} />
        <Route
          path="/login"
          element={<Login setIsLoggedIn={setIsLoggedIn} />}
        />
        <Route path="/register" element={<Register />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />

        <Route path="/pandith-parichaya" element={<PandithParichayaPage />} />
        {/* <Route path="/payment" element={<UserPaymentPage />} /> */}
        <Route
          path="/purohit-details"
          element={<UnbluredPurohitDetailsPage />}
        />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/temple-dashboard" element={<TempleDashboard />} />
        

        {/* Purohit Routes */}
        <Route path="/purohit-dashboard" element={<PurohitDashBoardPage />} />
        <Route path="/purohit-edit" element={<PurohitEditPage />} />
        <Route
          path="/purohit-registration"
          element={<PurohitRegistrationPage />}
        />
        <Route path="/temple-registration"
        element={<TempleRegistration/>}/>
          <Route path="/pooja-kits"
        element={<PoojaKitsPage/>}/>

        <Route path="/temple-editpage"
        element={<TempleEditPage/>}/>
        <Route
          path="/purohit-subscription"
          element={<PurohitSubscriptionPage />}
        />

          {/* //TempleSevasPage */}
        <Route path="/TempleSevasPage" element={<TempleSevasPage />} />

        {/* Legal Pages */}
        <Route path="/terms" element={<TermsAndConditionsPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/agreement" element={<TermsPrivacyAgreement />} />
      </Routes>

      <Footer />
    </Router>
  );
}



 